import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from '../../nest-api';

@Injectable()
export class PayrollProcessThaiReportProvider {

  private _service: string = 'payroll';
  private _model: string = 'payrollprocessThaireport';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadTemplateComponent(empStatus: any, gender: any, religion: string, marital: string,
    skip: any, limit: any, searchByFullname?: any): Observable<any> {
    const _method: string = 'GET';
    const _func: string = 'downloadTemplateComponent';
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    if (typeof empStatus !== 'undefined' && empStatus !== null) _urlParams.empStatus = empStatus;
    if (typeof gender !== 'undefined' && gender !== null) _urlParams.gender = gender;
    if (typeof religion !== 'undefined' && religion !== null) _urlParams.religion = religion;
    if (typeof marital !== 'undefined' && marital !== null) _urlParams.marital = marital;
    if (typeof skip !== 'undefined' && skip !== null) _urlParams.skip = skip;
    if (typeof limit !== 'undefined' && limit !== null) _urlParams.limit = limit;
    if (typeof searchByFullname !== 'undefined' && searchByFullname !== null) _urlParams.search = searchByFullname;

    const _url = this.nestApiProvider.urlBuilder(_method, this._model, _func, _params, _urlParams, this._service);
    return this.nestApiProvider.requestBlob(_method, _url, _func, _params, _body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/payroll-process-thai-report/payroll-process-thai-report.ts